<app-embed
  [loading]="loading()"
  [header]="header"
  [theme]="theme"
  [info]="info"
  [name]="project()?.name"
  [logoUrl]="logoUrl()"
  [coverImageUrl]="coverImageUrl()"
  [metaLines]="metaLines()"
  [updates]="updates()"
  [project]="project()"
  [infoComponent]="infoComponent()"
  [infoComponentProps]="infoComponentProps()"
></app-embed>
